module.exports = __webpack_public_path__ + "img/default_main.c901350f.png";